// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.merge-writer-names-form {
  display: flex;
  flex-direction: column;
  gap: 4rem;
}
.merge-writer-names-form .writer-selection-list {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.merge-writer-names-form .writer-selection-card {
  border: 1px solid #c4c4c4;
  border-top: 2px solid #000;
}
.merge-writer-names-form .writer-selection-card .writer-selection-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem;
  border-bottom: 1px solid #c4c4c4;
}
.merge-writer-names-form .writer-selection-card .writer-selection-card-name {
  font-size: 1.6rem;
  font-weight: 700;
}
.merge-writer-names-form .writer-selection-card .writer-selection-card-ipi {
  padding: 1.5rem 1.5rem 1.5rem 5rem;
  font-size: 1.4rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar/MergeWriterNamesForm/index.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAIE;EACE,yBAAA;EACA,0BAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;AAFN;AAKI;EACE,iBAAA;EACA,gBAAA;AAHN;AAMI;EACE,kCAAA;EACA,iBAAA;AAJN","sourcesContent":["@use '@Styles/variables';\n\n.merge-writer-names-form {\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n\n  .writer-selection-list {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n  }\n\n  .writer-selection-card {\n    border: 1px solid variables.$greyColorForBorder;\n    border-top: 2px solid variables.$blackColor;\n\n    .writer-selection-card-header {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 1.5rem;\n      padding: 1.5rem;\n      border-bottom: 1px solid variables.$greyColorForBorder;\n    }\n\n    .writer-selection-card-name {\n      font-size: 1.6rem;\n      font-weight: 700;\n    }\n\n    .writer-selection-card-ipi {\n      padding: 1.5rem 1.5rem 1.5rem 5rem;\n      font-size: 1.4rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
